<template>
<v-container fluid id="footer" class="d-flex flex-column flex-nowrap justify-start align-center">

	<div class="dark-panel d-flex justify-space-around align-center flex-wrap">
		<div class="noise noiseBlkPanel"></div>

		<div class="panelOption">
			<h1 class="wrkT1 mont fw7 px-5">
				<span class="rsBr">Let's Build</span>
				<span class="rsBr"> Something!</span>
			</h1>
		</div>
		<div class="panelOption">
			<a href="mailto:kcdcox@gmail.com?Subject=Hello"
				style="text-decoration:none !important; text-decoration:none;" target="_top">
				<h1 class="wrkT3 mont fw6">
					Get in Touch
				</h1>
			</a>
		</div>
		<div class="panelOption">
			<router-link to="/projects" class="nav-link">
				<h1 class="wrkT2 mont fw7">
					See My<br>Projects
				</h1>
			</router-link>
		</div>
	</div>
	<!--==================================================CIRCLE-ICONS================-->
	<div class="footIcons d-flex justify-center align-center" id="contact"> 	
			<a href="https://www.linkedin.com/in/kcdcox" tag="div"
				class="purpCircle d-flex justify-center align-center">
				<v-icon class="socialIcon">{{li}}</v-icon>
			</a>
			<a tag="div" href="mailto:kcdcox@gmail.com?Subject=Hello" target="_top"
				class="purpCircle d-flex justify-center align-center">
				<v-icon class="socialIcon">{{email}}</v-icon>
			</a>
			<a tag="div" href="https://github.com/kcdcox" class="purpCircle d-flex justify-center align-center">
				<v-icon class="socialIcon">{{git}}</v-icon>
			</a>
	</div>
	<!-- =================================================LOGO-DATE=============== -->
	<div class="logoBox d-flex flex-column align-center">
		<img src="../../images/logo/kcdcoxlogo.png" class="footLog">
		<h3 class="mont fw5 fs14p copyR">
			Kevin Cox &#169; TwentyNineteen
		</h3>
	</div>

	<div class="triangle"></div>
	<div class="noise noise02"></div> 

</v-container>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
import { mdiLinkedin, mdiEmailOutline, mdiGithubCircle } from '@mdi/js';

export default {
	name: 'FootComponent',
	data() {
    return {
			li: mdiLinkedin,
			email: mdiEmailOutline,
			git: mdiGithubCircle
		};
  },
};
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style>
#footer{
  position: relative !important;
	bottom: 0;
	left: 0;
	width: 100%;
  height: 450px;
	background-color: #8961A0;
	z-index: 10;
  overflow: visible !important; }
.dark-panel {
	height: auto;
	position: absolute;
	padding-top: 20px;
	padding-bottom: 20px;
	top: -50px !important;
	text-align: center;
	width: 50vw;
	min-width: 300px;
	max-width: 800px;
	border-radius: 15px;
	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
	background-color: #323232;}
.panelOption{
	width: 13vw;
	max-width: calc( 30% - 2vw);
	height: auto;
	margin-left: 1vw;
	margin-right: 1vw;
	position: relative;
	display: block;}
.wrkT1, .wrkT2, .wrkT3 {
	position: relative;
	width: 100%;
	margin: 10px auto;
	text-align: center;
	color: white;
	font-size: calc(14px + 0.5vw);
	line-height: calc(14px + 1vw);}
.wrkT2:hover { color: #4EA792EF;}
.wrkT3 {
	font-size: calc(10px + 0.6vw);
	border-radius: 25px;
	border: 3px solid #4EA792EF;
	transition: background-color 0.5s ease;
	background-color: none;
	line-height: 50px;}
.wrkT3:hover { background-color: #4EA792EF;}
.footIcons {
	position: relative;
	top: 130px;}
.purpCircle {
	position: relative;
	width: 100px;
	height: 100px;
	margin-left: 10px;
	margin-right: 10px;
	cursor: pointer;
	border-radius: 50%;
	border: 2px solid white;
	transition: background-color 0.5s ease;
	background-color: #323232EE;}
.purpCircle:hover { background-color: #4EA792;}
.socialIcon{
	position: relative;
	height: 40px !important;
	width: 40px !important;
	color: white !important;
	cursor: pointer;}
.socialIcon:hover{ color: #8961A0 !important;}
.ftIco {
	position: absolute;
	width: 40%;
	height: 100%;
	left: 30%;
	object-fit: contain;}
.logoBox {
  position: absolute;
	bottom: 40px;
	width: 100%;
  left: 0;
  padding: 0;
  margin: 0;
	height: 130px;
	overflow: visible;}
.footLog {
	position: relative;
	object-fit: contain;
	opacity: 0.95;
	width: 150px;
	margin: 0 auto;
	margin-bottom: 20px;
	height: 80px;
	top: 20px;}
.copyR {
  font-size: 16px;
	text-align: center;
	position: relative;
	top: 15px;
	height: 20px;
	width: 100%;}
/*===================RESPONSIVENESS===================*/
/*================================================SM==*/	
@media screen and (max-width: 767px) {
	.wrkT2 { display: none;}
	.rsBr { display: inline;}
	.logo { height: 18vw;}
	.panelOption{ width: 50vw; max-width: 80%;}
	.conIconCont {
		width: 370px;
		height: 100px;
		left: calc(50% - 185px);}
	.purpCircle {
		top: 27px;
		width: 90px;
		height: 90px;
		margin-left: 10px;
		margin-right: 10px;}
}
/*================================================MD==*/
@media (min-width: 768px) and (max-width: 991px) {
	.wrkT2 { display: none;}
	.wrkT3 { width: 50%;}
	.panelOption{ width: 30vw; max-width: 100%;}
	.rsBr { display: inline;}
}/*================================================LG==*/
@media (min-width: 992px) and (max-width: 1199px) {
	.wrkT2 {display: none;}
	.panelOption{ width: 40vw;max-width: 100%;}
	.wrkT3 {width: 50%;}
	.rsBr {display: inline;}
}/*================================================XL==*/
@media (min-width: 1199px) {
	.rsBr {display: block;}}
.triangle{
	position: absolute;
	display: block;
	bottom: 0;
	right: 0;
	z-index: -10;
	width: calc(50vw + 225px);
	height: 100%;
	border-bottom: 450px solid #4EA792;
	border-left: 400px solid #8961A0;}
.noise02{opacity: 0.2; z-index: -9;}
.noiseBlkPanel{ opacity: 0.07; z-index: 0;}
</style>
